// This file is used for any helpers

import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'

// To disable link
export const StyledLink = styled((props) => <Link {...props} />)`
  pointer-events: none;
`

// Blog

export const renderReadMoreTrad = (lang: string) => {
  switch (lang) {
    case 'en-us':
      return 'Read more'
    case 'fr-fr':
      return 'En savoir plus'
    default:
      return 'Read more'
  }
}
